import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-color-picker',
  templateUrl: './formly-color-picker.component.html',
  styleUrls: ['./formly-color-picker.component.scss']
})
export class FormlyColorPickerComponent extends FieldType {}
